import React from "react";

class LoadingIndicator extends React.Component {
    render() {
        return (
            <div className="loading-indicator-container">
                <span>Loading...</span>
            </div>
        );
    }
}

export default LoadingIndicator;